import React, { Suspense, useContext, useEffect, useRef } from 'react';
import { useProgress } from '@react-three/drei';
import gsap from 'gsap';

import Mark from 'assets/img/logo.png';
import { ControlContext } from 'provider/ControlProvider';
export default function Home() {
  const { progress, active, loaded } = useProgress();
  const { controlStatus, setControlStatus } = useContext(ControlContext);
  const content = useRef<any>();
  const bg = useRef<any>();
  const slideEffect = () => {
    gsap.to(content.current, {
      duration: 0.8,
      ease: 'power1.out',
      opacity: 0,
      onComplete: () => {
        gsap.to(bg.current, {
          duration: 2,
          ease: 'power1.out',
          opacity: 0,
          onComplete: () => {
            setControlStatus(true);
          },
        });
      },
    });
  };
  useEffect(() => {
    if (loaded >= 33 && progress === 100) slideEffect();
  }, [loaded]);
  return !controlStatus ? (
    <div
      ref={bg}
      className='w-screen h-screen absolute z-30 flex items-center justify-center bg-zinc-900 select-none'
    >
      <Suspense fallback={null}>
        {/* {loaded !== 2 ? (
          <p className='absolute z-40 text-cyan-500 font-serif text-3xl transition-all font-bold'>
            {progress.toFixed(0)}
          </p>
        ) : (
          <p
            className='absolute z-40 text-cyan-500 hover:text-cyan-200 font-serif text-xl font-bold'
            ref={text}
          >
            Loading...
          </p>
        )} */}
        <div className='p-10 text-gray-500 h-screen w-screen flex justify-center items-center text-center'>
          <div
            ref={content}
            className='relative -translate-y-20 flex flex-col justify-center items-center space-y-5'
          >
            <div className='flex justify-center items-center space-x-4'>
              <img src={Mark} className={'w-auto h-24'} />
            </div>
            <p className='font-bold text-2xl'>3D Simple City Configurator</p>
          </div>
        </div>
      </Suspense>
    </div>
  ) : null;
}
